import { useEffect, useState } from "react";
import "../css/RecentBox.css";
import {buildMatchId} from "../utils/matchUtils";

const RecentBox = ({ teamName }) => {
  const [list, setList] = useState([]);

  useEffect(() => {
    if (!teamName) {
      setList([]);
      return;
    }
    const url =  `${process.env.REACT_APP_API_URL}/api/soccer/team/${encodeURIComponent(teamName)}/recent`;
    //const url = `http://localhost:5001/api/soccer/team/${encodeURIComponent(teamName)}/recent`;

    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        // newest first
        const sorted = [...data].sort((a, b) => new Date(b.utcDate) - new Date(a.utcDate));
        setList(sorted);
      })
      .catch((err) => {
        console.log("recent error:", err);
        setList([]);
      });
  }, [teamName]);

  useEffect(() => {
    if (!list.length) return;

    list.forEach(async (match) => {
      if (!match.score || match.score.home == null) return; // skip incomplete

      const homeGoals = match.score.home;
      const awayGoals = match.score.away;
      const actualWinner = homeGoals > awayGoals ? 'home'
                         : awayGoals > homeGoals ? 'away'
                         : 'draw';

      const matchId = buildMatchId(match.homeTeam, match.awayTeam, match.utcDate);

      console.log("matchId built:", matchId);
      console.log("actualWinner:", actualWinner);

      const response= await fetch(`${process.env.REACT_APP_API_URL}/api/predictions/updateGame`, { 
      //const response = await fetch('http://localhost:5001/api/predictions/updateGame', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ matchId, actualWinner }),
      });

      console.log("updateGame response status:", response.status);
    });
  }, [list]);

  return (
    <div className="recent-box">
      <div className="recent-header">
        <span>Date</span>
        <span>Match</span>
        <span className="score-col">Score</span>
      </div>

      <div className="recent-list">
        {list.length === 0 ? (
          <p className="recent-empty">Loading recent matches.</p>
        ) : (
          list.map((match, index) => (
            <div key={index} className="recent-row">
              <span className="date-col">
                {new Date(match.utcDate).toLocaleDateString()}
              </span>

              <span className="match-col">
                {match.homeTeam} vs {match.awayTeam}
              </span>

              <span className="score-col">
                {match.score
                  ? `${match.score.home ?? "-"} - ${match.score.away ?? "-"}`
                  : "-"}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default RecentBox;